const FLOW_INPUT_COMPONENT_TYPES = new Set([
  "TextInput",
  "TextArea",
  "CheckboxGroup",
  "RadioButtonsGroup",
  "Dropdown",
  "DatePicker",
  "OptIn",
  "ChipsSelector",
]);

export function extractWhatsappFlowScreenFields(body) {
  const screens = Array.isArray(body?.screens) ? body.screens : [];
  const fields = [];

  screens.forEach((screen, screenPosition) => {
    const screenTitle =
      screen?.title || screen?.id || `Screen ${screenPosition + 1}`;
    const seenInScreen = new Set();

    const walk = (node) => {
      if (Array.isArray(node)) {
        node.forEach(walk);
        return;
      }
      if (!node || typeof node !== "object") {
        return;
      }
      if (
        typeof node.name === "string" &&
        FLOW_INPUT_COMPONENT_TYPES.has(node.type) &&
        !seenInScreen.has(node.name)
      ) {
        seenInScreen.add(node.name);
        fields.push({
          screenPosition,
          screenTitle,
          screenField: node.name,
          label: node.label || node.name,
          fieldType: node.type,
        });
      }
      Object.values(node).forEach(walk);
    };

    walk(screen?.layout);
  });

  return fields;
}

export function getMappedFieldsSummary(flowScreenRows) {
  const rows = flowScreenRows || [];
  const mapped = rows.filter((row) => Boolean(row.customField)).length;

  return { mapped, total: rows.length };
}
